import React from 'react'
import PropTypes from 'prop-types'
import { VFText } from '@vfgroup-oneplatform/foundation/Components'

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { View } from 'react-native'

import TextLoading from '../../LoadingScreens/TextLoading'

const VFTextWithLoader = ({
  style,
  i18nKey,
  isLoading,
  background,
  foreground,
  loaderWidth,
  loaderHeight,
  placeHolders,
  numberOfLines
}) => {
  const theme = useTheme()
  if (isLoading) {
    return (
      <View style={style}>
        <View
          style={{
            height: loaderHeight,
            width: loaderWidth
          }}
        >
          <TextLoading
            width={loaderWidth}
            height={loaderHeight}
            background={background ?? theme.colors.shimmerCenterColor}
            foreground={foreground ?? theme.colors.shimmerEdgesColor}
          />
        </View>
      </View>
    )
  }
  return (
    <VFText
      style={style}
      i18nKey={i18nKey}
      placeHolders={placeHolders}
      numberOfLines={numberOfLines}
    />
  )
}

VFTextWithLoader.propTypes = {
  style: PropTypes.any,
  isLoading: PropTypes.bool,
  i18nKey: PropTypes.string,
  background: PropTypes.string,
  foreground: PropTypes.string,
  loaderWidth: PropTypes.number,
  loaderHeight: PropTypes.number,
  numberOfLines: PropTypes.string,
  placeHolders: PropTypes.arrayOf(PropTypes.string)
}

export default VFTextWithLoader
